import { keepPreviousData, useQuery } from "@tanstack/vue-query";
import { unref, type MaybeRef } from "vue";

import URLS from "@/autogen/urls";
import type { Newsletter } from "@/types/newsletter";

import type { RenderResult } from "../emails/render";
import { useNewsletterId, useXsrfHeaders } from "../utils";

export const useSubscribePagePreviewQuery = ({
  newsletter,
  enabled,
}: {
  newsletter: MaybeRef<Newsletter>;
  enabled?: MaybeRef<boolean>;
}) => {
  const newsletterId = useNewsletterId();
  const headers = useXsrfHeaders();

  const query = useQuery({
    queryKey: [newsletterId, "subscribe-page-preview", { newsletter }],
    enabled: enabled,
    gcTime: 10_000,
    refetchOnReconnect: false,
    refetchOnWindowFocus: false,
    async queryFn({ signal }): Promise<RenderResult> {
      const response = await fetch(URLS["render-subscribe-template"](), {
        method: "post",
        signal: signal,
        body: JSON.stringify({
          newsletter: unref(newsletter),
        }),
        headers: {
          ...headers.value,
          accept: "application/json",
          "content-type": "application/json",
        },
      });

      const json = (await response.json()) as {
        result: string;
      };

      return {
        email: "",
        web: "",
        portal: "",
        subscribe: json.result,
        archive: "",
      };
    },
    placeholderData: keepPreviousData,
  });

  return query;
};
